<template>
  <div>
    <div id="boxPrint" class="row">
      <div class="col-md-12">
        <print-content>
          <loading-animation
            :active.sync="loading"
            :is-full-page="false"
            :opacity="1"
            color="#5895FF"
          />
          <table
            class="table b-table b-table-stacked-xs table-bordered table-sm bg-white"
          >
            <tbody>
              <tr>
                <td colspan="4" class="text-center align-center">
                  <h4>Relatório de Participação SCFV</h4>
                </td>
              </tr>

              <!-- Grupo -->
              <template v-if="item.grupo">
                <tr>
                  <td colspan="4">
                    Nome do Grupo: <b>{{ item.grupo.nome_grupo }}</b>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Faixa Etária: <b>{{ item.grupo.faixa_etaria_nome }}</b>
                  </td>
                  <td colspan="2">
                    Inscritos: <b>{{ item.grupo.inscritos }}</b>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Unidade do cadastro: <b>{{ item.grupo.unidade }}</b>
                  </td>
                  <td colspan="2">
                    Status: <b>{{ item.grupo.status_descricao }}</b>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    Periodicidade: <b>{{ item.grupo.dias_semana_nomes }}</b>
                  </td>
                  <td colspan="2">
                    Base física das Atividades: <b>{{ item.grupo.unidade_base }}</b>
                  </td>
                </tr>
                <tr>
                  <td colspan="4">
                    Técnico de Referência: <b>{{ item.grupo.responsavel }}</b>
                  </td>
                </tr>
              </template>

              <tr>
                <td colspan="4" class="text-center align-center">
                  <h4>Informações da Atividade</h4>
                </td>
              </tr>
              <tr>
                <td>
                  ID: <strong>{{ item.id }}</strong>
                </td>
                <td>
                  PROTOCOLO: <strong>{{ item.protocolo }}</strong>
                </td>
                <td>
                  CADASTRADO:
                  <strong>{{ item.created_at }}</strong>
                </td>
                <td>
                  ATUALIZADO:
                  <strong>{{ item.updated_at }}</strong>
                </td>
              </tr>
              <tr v-if="item.responsavel">
                <td colspan="2">
                  TÉCNICO RESPONSÁVEL:
                  <strong>{{ item.responsavel.name }}</strong>
                </td>
                <td colspan="2">
                  UNIDADE:
                  <strong>{{ item.unidade.nome }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  TEMA:
                  <strong>{{ item.tema }}</strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  TIPO:
                  <strong>{{ item.tipo }}</strong>
                </td>
                <td colspan="2">
                  STATUS:
                  <strong v-html="item.status_nome"></strong>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  DATA:
                  <strong>{{ item.data | formatDate() }}</strong>
                </td>
                <td>
                  HORA:
                  <strong>{{ item.hora_print }}</strong>
                </td>
                <td>
                  DURAÇÃO:
                  <strong>{{ item.duracao }}</strong>
                </td>
              </tr>

              <tr>
                <td colspan="4" v-if="item.participantes_presentes" class="p-3">
                  <p class="small text-muted">Participantes da Atividade</p>
                  <table class="table b-table b-table-stacked-xs table-sm bg-white">
                    <thead>
                      <tr>
                        <th>Nome</th>
                        <th>Data de Nascimento</th>
                        <th>Situação Prioritária</th>
                        <th>Registro de Participação</th>
                        <th>Data do Registro</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(key, index) in item.participantes_array"
                        :key="item.participantes_array[index]['id']"
                      >
                        <td>
                          <b>{{ item.participantes_array[index]["nome"] }}</b>
                        </td>
                        <td>
                          <b>{{
                            item.participantes_array[index]["data_nascimento_formatada"]
                          }}</b>
                        </td>
                        <td>
                          <b>{{
                            $options.filters.formatSituacaoPrioritaria(
                              item.participantes_array[index]["situacao_prioritaria"]
                            )
                          }}</b>
                        </td>
                        <td>
                          <b>{{ $options.filters.formatDate(item.updated_at) }}</b>
                        </td>
                        <td width="27px">
                          <span
                            v-if="
                              item.participantes_presentes.indexOf(
                                item.participantes_array[index]['id']
                              ) != -1
                            "
                          >
                            <i class="fas fa-check"></i> SIM
                          </span>
                          <span v-else> <i class="fas fa-times"></i> NÃO </span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>

          <print-footer
            v-if="
              item.responsavel &&
              item.responsavel.tecnico &&
              item.responsavel.tecnico.assinatura_digital
            "
            :tecnico="item.responsavel.tecnico"
            class="mt-0"
            :assinatura="item.responsavel.tecnico.assinatura_digital"
            :wpp="wpp"
            :email="email"
          />
        </print-content>
        <div class="row pt-4 px-0 d-flex justify-content-end no-print">
          <div class="col-auto px-2 text-right">
            <form-toggle
                grid="12"
                mt="0"
                v-model="email"
                label="Email"
            />
            <form-toggle
                grid="12"
                mt="0"
                v-model="wpp"
                label="Telefone/WhatsApp"
            />
            <a class="btn btn-default" @click="$router.go(-1)">
              <i class="mdi mdi-arrow-left" />
            </a>
            <b-button
              variant="outline-dark"
              @click="exportar()"
              :title="$t('Exportar')"
              v-b-tooltip.hover
            >
              <i class="fas fa-file-excel"></i>
            </b-button>
            <a class="btn btn-sm py-1 btn-primary" @click="print()">
              <i class="mdi mdi-printer mdi-18px" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Show",
  data() {
    return {
      loading: true,
      item: {},
      app_cidade: this.$store.state.settings.app_cidade,
      app_data_atual: this.$store.state.settings.app_data_atual,
      email: true,
      wpp: true
    };
  },
  mounted() {
    this.getItem();
  },
  methods: {
    getItem() {
      this.loading = true;
      axios
        .get(`api/dashboard/atividades/${this.$route.params.id}`)
        .then((response) => {
          this.item = response.data.data;
          this.loading = false;
          if (this.item.status == 21) {
            this.listapresenca = true;
          }
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    exportar() {
      this.loading = true;
      swal.fire({
        title: "Aguarde! O Arquivo está sendo gerado.",
        text: "O tempo para finalizar pode demorar dependendo a quantidade De registros.",
        imageUrl: `${window.urlbase}img/load.gif`,
        showConfirmButton: false,
      });
      axios
        .get(`api/dashboard/report/export/inscritos/${this.$route.params.id}`)
        .then((response) => {
          this.loading = false;

          swal.fire({
            title: "Arquivo Pronto para Download!",
            html: `<a href="${response.data.link}" target="_blank">Clique aqui para baixar</a>`,
            icon: "success",
            showConfirmButton: false,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
